"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zodCaseFilterSchema = exports.CaseFilterSchema = exports.caseFilterhash = exports.caseFilterHasOnlyTenantId = exports.FilterType = void 0;
const Joi = __importStar(require("joi"));
const __1 = require("..");
const cases_1 = require("../cases");
const documents_1 = require("../documents");
const payment_plans_1 = require("../economy/payment-plans");
const interactions_1 = require("../interactions");
const zod_1 = require("zod");
var FilterType;
(function (FilterType) {
    FilterType["Exact"] = "EXACT";
    FilterType["Containing"] = "CONTAINING";
})(FilterType || (exports.FilterType = FilterType = {}));
const caseFilterHasOnlyTenantId = (filter) => {
    const keys = Object.keys(filter);
    return keys.length === 1 && keys[0] === 'tenantId';
};
exports.caseFilterHasOnlyTenantId = caseFilterHasOnlyTenantId;
const caseFilterhash = (filter) => JSON.stringify(Object.entries(filter)
    .filter((d) => typeof d[1] !== undefined &&
    !(Array.isArray(d[1]) && d[1].length === 0))
    .sort((a, b) => a[0].localeCompare(b[0])));
exports.caseFilterhash = caseFilterhash;
exports.CaseFilterSchema = Joi.any();
exports.zodCaseFilterSchema = zod_1.z.object({
    creditorIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    caseEndReasonIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    caseGroups: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    casesImportsIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    caseCreationDate: __1.DateIntervalSchema.optional(),
    caseSeqIds: zod_1.z.array(zod_1.z.number().int()).optional(),
    exceptCaseSeqIds: zod_1.z.boolean().optional(),
    caseIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    caseStatuses: zod_1.z.array(zod_1.z.nativeEnum(cases_1.CaseStatus)).optional(),
    caseTypes: zod_1.z.array(zod_1.z.nativeEnum(cases_1.CaseType)).optional(),
    hasAlternativeContact: zod_1.z.boolean().optional(),
    isCompany: zod_1.z.boolean().optional(),
    activePaymentMethod: zod_1.z.boolean().optional(),
    property: zod_1.z
        .object({
        scope: zod_1.z.union([
            zod_1.z.literal('case_groups'),
            zod_1.z.literal('creditor'),
            zod_1.z.null(),
        ]),
        scopeId: zod_1.z.string().uuid(),
        referenceType: zod_1.z.union([
            zod_1.z.literal(__1.Entity.Case),
            zod_1.z.literal(__1.Entity.CaseVoucher),
            zod_1.z.literal(__1.Entity.Creditor),
        ]),
        handle: zod_1.z.string(),
        value: zod_1.z.string(),
        commaSeparated: zod_1.z.boolean(),
    })
        .optional(),
    isPaused: zod_1.z.boolean().optional(),
    hasUpdateIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    doNotHaveUpdateIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    hasCurrentPauseIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    withResponsibleIds: zod_1.z
        .array(zod_1.z.union([zod_1.z.string().uuid(), zod_1.z.null()]))
        .optional(),
    doNotHaveCurrentPauseIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    economyMinBalance: zod_1.z.number().optional(),
    economyMaxBalance: zod_1.z.number().optional(),
    economyOnlyVoucherTypeIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    billingModelIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    billingAppendixSetupIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    inWorkflowIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    currentTaskIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    nextTaskIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    noNextTask: zod_1.z.boolean().optional(),
    alternativeWorkflowPaths: zod_1.z.array(zod_1.z.string()).optional(),
    documentTypes: zod_1.z.array(zod_1.z.nativeEnum(documents_1.DocumentTypes)).optional(),
    documentTypesIsSigned: zod_1.z.boolean().optional(),
    paymentPlansStatuses: zod_1.z.array(zod_1.z.nativeEnum(payment_plans_1.PaymentPlanStatus)).optional(),
    isNotHavingTheAbovePaymentPlansStatuses: zod_1.z.boolean().optional(),
    interactionStates: zod_1.z
        .array(zod_1.z.union([zod_1.z.nativeEnum(interactions_1.OutgoingState), zod_1.z.nativeEnum(interactions_1.IncomingState)]))
        .optional(),
    interactionDirections: zod_1.z.array(zod_1.z.nativeEnum(interactions_1.Direction)).optional(),
    emailToContains: zod_1.z.string().optional(),
    interactionTypes: zod_1.z.array(zod_1.z.nativeEnum(interactions_1.InteractionType)).optional(),
    noneOfTheAboveInteractions: zod_1.z.boolean().optional(),
    maxRkiRegistrations: zod_1.z.number().optional(),
    minRkiRegistrations: zod_1.z.number().optional(),
    isReportedByCollector: zod_1.z.boolean().optional(),
    companyTypes: zod_1.z.array(zod_1.z.string()).optional(),
    companyStatuses: zod_1.z.array(zod_1.z.string()).optional(),
    companyBranches: zod_1.z.array(zod_1.z.string()).optional(),
    gender: zod_1.z.nativeEnum(__1.Gender).optional(),
    zipcodes: zod_1.z.array(zod_1.z.number()).optional(),
    courtIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    hasAddress: zod_1.z.boolean().optional(),
    hasPhone: zod_1.z.boolean().optional(),
    hasEmail: zod_1.z.boolean().optional(),
    withSatisfactions: zod_1.z.array(zod_1.z.number()).optional(),
    visitedByUserIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    visitedAt: __1.DateIntervalSchema.optional(),
    offset: zod_1.z.number().optional(),
    limit: zod_1.z.number().optional(),
});
//# sourceMappingURL=index.js.map